enum CommonFilterType {
  OUTLET_OPTIONAL,
  OUTLET_MANDATORY,
  OUTLET_MULTIPLE,
  TEAM_OPTIONAL,
  BRAND_OPTIONAL,
  USER_MULTIPLE,
  GROUP_MULTIPLE,
  DOSSIER_TAG,
}

export default CommonFilterType;

export const OUTLET_FILTER_TYPES = [CommonFilterType.OUTLET_OPTIONAL, CommonFilterType.OUTLET_MANDATORY, CommonFilterType.OUTLET_MULTIPLE];
